<template>
	<form-field :label="label" :error="error" :require="require">
		<input-text v-bind="$attrs" />
		<slot name="textprepend"></slot>
	</form-field>
</template>

<script setup>
import FormField from '@/components/Form/Field.vue';
import InputText from 'primevue/inputtext';

defineProps({
	label: String,
	error: Object,
	require: {
		type: Boolean,
		default: false,
	},
});
</script>
